'use client';

import React from 'react';
import { ErrorBoundary } from '@benzinga/core-ui';
import { useFirstInteractionMade } from '@benzinga/hooks';

const FloatingWNSTNWidget = React.lazy(() =>
  import('@benzinga/ads').then(module => ({ default: module.FloatingWNSTNWidget })),
);

export function DeferredHomeChatWidget() {
  const hasUserInteracted = useFirstInteractionMade();
  if (!hasUserInteracted) return null;

  return (
    <ErrorBoundary name="home-page-floating-wnstn-widget">
      <React.Suspense fallback={null}>
        <FloatingWNSTNWidget />
      </React.Suspense>
    </ErrorBoundary>
  );
}
